<template>
  <div class="row mt-4" v-if="isFormEligibleForBankDropDown">
    <div class="col-12 form-field">
      <div class="mb-4" v-if="isBankDetailsCheckedAsHidden">
        <header-with-tooltip :tooltip-text="bankAccountNumberSlackHelp" :is-h-t-m-l="true" :show-icon="true">
          <span class="mr-1">{{FORM_LABELS.BANK_ACCOUNT_NUMBER}}</span>
        </header-with-tooltip>
        <div class="mb-2 select-style my-2">
            <model-list-select
                :list="showBankAccount ? bankAccountValues : bankAccountValuesMasked"
                :optionValue="'value'"
                :optionText="'text'"
                name="currentFormData.bankAccountNumber"
                v-validate="'required'"
                id="currentFormData.bankAccountNumber"
                data-vv-validate-on="input"
                data-lpignore="true"
                @input="autofillBankDetails"
                v-model="currentFormData.bankAccountNumber"
                :key="bankAccountNumberKey"
            />
        </div>

        <show-errors :for-item="'currentFormData.bankAccountNumber'"
                     :form-errors="errors"
                     :field-name="FORM_LABELS.BANK_ACCOUNT_NUMBER"
                     :max-length="18" />
        <div class="mt-1 d-inline-block">
          <input type="checkbox"
                 id="showBankAccount"
                 v-model="showBankAccount"/>
          <span @click="showBankAccount = !showBankAccount" class="ml-1 d-inline-block cursor-pointer">{{FORM_LABELS.SHOW_BANK_ACCOUNT_NUMBER}}</span>
        </div>
      </div>

      <div v-if="isBankDetailsCheckedAsHidden">
        <div class="title pt-2">
          <span>{{FORM_LABELS.ACCOUNT_HOLDER_NAME}}</span>
        </div>
        <div class="mb-4 my-2">
          <input
              class="form-control"
              name="currentFormData.bankAccountHolderName"
              v-model="currentFormData.bankAccountHolderName"
              id="currentFormData.bankAccountHolderName"
              autocomplete="off"
              :disabled="true"
              data-lpignore="true"
          >
          <show-errors :for-item="'currentFormData.bankAccountHolderName'" :form-errors="errors" :field-name="FORM_LABELS.ACCOUNT_HOLDER_NAME" :max-length="60" />
        </div>
      </div>


      <div v-if="isBankDetailsCheckedAsHidden">
        <div class="title pt-2">
          <span>{{FORM_LABELS.BANK_NAME}}</span>
        </div>
        <div class="mb-4 my-2">
          <input
              class="form-control"
              name="currentFormData.bankName"
              v-model="currentFormData.bankName"
              id="currentFormData.bankName"
              data-lpignore="true"
              autocomplete="nope"
              :disabled="true"
          >
          <show-errors :for-item="'currentFormData.bankName'" :form-errors="errors" :field-name="FORM_LABELS.BANK_NAME" :max-length="60" />

        </div>
      </div>

      <!-- Hidden input element to prevent chrome from auto populating country dropdown with username  -->
      <input autocomplete="off" data-lpignore="true" class="hidden-input-field" />
      <input autocomplete="off" data-lpignore="true" type="password" class="hidden-input-field" />



      <div class="row no-gutters" v-if="isBankDetailsCheckedAsHidden">
        <div class="col-lg-6 col-12">
          <div class="title">
            <span>{{FORM_LABELS.BANK_COUNTRY_OF_ORIGIN}}</span>
          </div>
          <div class="my-2 select-style pr-lg-3">
            <model-list-select
                :list="this.adminDataList.countryCodeList"
                :optionValue="'value'"
                :optionText="'text'"
                id="bank-country-list"
                name="currentFormData.bankCountry"
                v-model="currentFormData.bankCountry"
                @input="updateBankCountry"
                class="form-control readonly-dropdown"
                :isDisabled="true"
                :key="componentKey"
            />
            <show-errors :for-item="'currentFormData.bankCountry'" :form-errors="errors" :field-name="FORM_LABELS.BANK_COUNTRY_OF_ORIGIN" />

          </div>
        </div>

        <div class="col-lg-6 col-12">
            <header-with-tooltip :tooltip-text="FORM_LABELS.IBAN_FULL_TEXT" :show-icon="true">
              <span class="mr-1">{{FORM_LABELS.BANK_IBAN}}</span>
            </header-with-tooltip>
          <div class="mb-2 my-2">
            <input
                class="form-control"
                name="currentFormData.bankIBAN"
                v-model="currentFormData.bankIBAN"
                id="currentFormData.bankIBAN"
                autocomplete="off"
                data-lpignore="true"
                :disabled="true"
                :type="showIBAN ? 'text':'password'"
            >
            <show-errors :for-item="'currentFormData.bankIBAN'"
                         :form-errors="errors"
                         :field-name="FORM_LABELS.BANK_IBAN"
                         :max-length="34" />
            <div class="mt-2 d-inline-block">
              <input type="checkbox"
                     class="cursor-pointer"
                     id="showIBAN"
                     v-model="showIBAN"/>
              <span @click="showIBAN = !showIBAN" class="ml-1 d-inline-block cursor-pointer">{{FORM_LABELS.SHOW_IBAN}}</span>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-12">
          <div class="title pt-2">
              <span>{{FORM_LABELS.BANK_AND_BRANCH_CODE}}</span>
          </div>
          <div class="mb-4 my-2 pr-lg-3">
            <input
                class="form-control"
                name="currentFormData.bankNumber"
                v-model="currentFormData.bankNumber"
                v-validate="'max:15'"
                id="currentFormData.bankNumber"
                autocomplete="nope"
                data-lpignore="true"
                :disabled="true"
            >
            <show-errors :for-item="'currentFormData.bankNumber'"
                         :form-errors="errors"
                         :field-name="FORM_LABELS.BANK_AND_BRANCH_CODE"
                         :max-length="15" />
          </div>
        </div>

        <div class="col-lg-6 col-12">
          <div class="title pt-2">
              <span>{{FORM_LABELS.BANK_SWIFT_CODE}}</span>
          </div>
          <div class="mb-4 my-2">
            <input
                class="form-control"
                name="currentFormData.bankSwiftCode"
                v-model="currentFormData.bankSwiftCode"
                id="currentFormData.bankSwiftCode"
                autocomplete="nope"
                data-lpignore="true"
                :disabled="true"
            >
            <show-errors :for-item="'currentFormData.bankSwiftCode'"
                         :form-errors="errors"
                         :field-name="FORM_LABELS.BANK_SWIFT_CODE"
                         :max-length="11" />
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 form-field pb-3" v-if="!isBankDetailsCheckedAsHidden">
      <div class="title mt-2 mb-3">
        <div class="font-italic text-red">Supplier does not have bank information registered with Autodesk. Please contact <a :href="CONSTANTS.ACCOUNTS_PAYABLE_SLACK" target="_blank">Accounts Payable via Lumi</a> for advice , or choose an alternate method of payment to proceed.</div>
      </div>
    </div>
  </div>
  <div class="row mt-4" v-else>
    <div class="col-12 form-field">

      <div class="title pt-2 required-field">
        <span>{{FORM_LABELS.BANK_NAME}}</span>
      </div>
      <div class="mb-4 my-2">
        <input
            class="form-control"
            name="currentFormData.bankName"
            v-model="currentFormData.bankName"
            id="currentFormData.bankName"
            data-lpignore="true"
            autocomplete="nope"
            v-validate="'required|max:60'"
            data-vv-validate-on="input"
        >
        <show-errors :for-item="'currentFormData.bankName'" :form-errors="errors" :field-name="FORM_LABELS.BANK_NAME" :max-length="60" />

      </div>

      <div class="title pt-2 required-field">
        <span>{{FORM_LABELS.BANK_COUNTRY_OF_ORIGIN}}</span>
      </div>
      <div class="mb-4 my-2 select-style">
        <model-list-select
            :list="this.adminDataList.countryCodeList"
            :optionValue="'value'"
            :optionText="'text'"
            id="bank-country-list"
            name="currentFormData.bankCountry"
            v-model="currentFormData.bankCountry"
            @input="updateBankCountry"
            v-validate="'required'"
            data-vv-validate-on="input"
            :key="componentKey"
        />
        <show-errors :for-item="'currentFormData.bankCountry'" :form-errors="errors" :field-name="FORM_LABELS.BANK_COUNTRY_OF_ORIGIN" />

      </div>

      <!-- Hidden input element to prevent chrome from auto populating country dropdown with username  -->
      <input autocomplete="off" data-lpignore="true" class="hidden-input-field" />
      <input autocomplete="off" data-lpignore="true" type="password" class="hidden-input-field" />

      <div class="row no-gutters">
        <div class="col-lg-6 col-12">
          <div class="title required-field">
            <span>{{FORM_LABELS.BANK_ACCOUNT_NUMBER}}</span>
          </div>
          <div class="mb-4 my-2 pr-lg-3">
            <input
                class="form-control"
                name="currentFormData.bankAccountNumber"
                v-model="currentFormData.bankAccountNumber"
                id="currentFormData.bankAccountNumber"
                autocomplete="off"
                v-validate="'required|max:18'"
                data-vv-validate-on="input"
                data-lpignore="true"
                :type="showBankAccountWhenFormNotPONONPO ? 'text':'password'"
            >
            <show-errors :for-item="'currentFormData.bankAccountNumber'"
                         :form-errors="errors"
                         :field-name="FORM_LABELS.BANK_ACCOUNT_NUMBER"
                         :max-length="18" />
            <div class="mt-1 d-inline-block">
              <input type="checkbox"
                     id="showBankAccount"
                     v-model="showBankAccountWhenFormNotPONONPO"/>
              <span @click="showBankAccountWhenFormNotPONONPO = !showBankAccountWhenFormNotPONONPO" class="ml-1 d-inline-block cursor-pointer">{{FORM_LABELS.SHOW_BANK_ACCOUNT_NUMBER}}</span>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-12">
            <header-with-tooltip :tooltip-text="FORM_LABELS.IBAN_FULL_TEXT" :show-icon="true"><span class="mr-1">{{FORM_LABELS.BANK_IBAN}}</span></header-with-tooltip>
          <div class="mb-4 my-2">
            <input
                class="form-control"
                name="currentFormData.bankIBAN"
                v-model="currentFormData.bankIBAN"
                id="currentFormData.bankIBAN"
                autocomplete="off"
                v-validate="'max:34'"
                data-lpignore="true"
                data-vv-validate-on="input"
                :type="showIBAN ? 'text':'password'"
            >
            <show-errors :for-item="'currentFormData.bankIBAN'"
                         :form-errors="errors"
                         :field-name="FORM_LABELS.BANK_IBAN"
                         :max-length="34" />
            <div class="mt-1 d-inline-block">
              <input type="checkbox"
                     class="cursor-pointer"
                     id="showIBAN"
                     v-model="showIBAN"/>
              <span @click="showIBAN = !showIBAN" class="ml-1 d-inline-block cursor-pointer">{{FORM_LABELS.SHOW_IBAN}}</span>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-12">
          <div class="title pt-2 required-field">
            <span>{{FORM_LABELS.BANK_AND_BRANCH_CODE}}</span>
          </div>
          <div class="mb-4 my-2 pr-lg-3">
            <input
                class="form-control"
                name="currentFormData.bankNumber"
                v-model="currentFormData.bankNumber"
                id="currentFormData.bankNumber"
                autocomplete="nope"
                data-lpignore="true"
                v-validate="'required|max:15'"
                data-vv-validate-on="input"
            >
            <show-errors :for-item="'currentFormData.bankNumber'"
                         :form-errors="errors"
                         :field-name="FORM_LABELS.BANK_AND_BRANCH_CODE"
                         :max-length="15" />
          </div>
        </div>

        <div class="col-lg-6 col-12">
          <div class="title pt-2">
            <span>{{FORM_LABELS.BANK_SWIFT_CODE}}</span>
          </div>
          <div class="mb-4 my-2">
            <input
                class="form-control"
                name="currentFormData.bankSwiftCode"
                v-model="currentFormData.bankSwiftCode"
                id="currentFormData.bankSwiftCode"
                autocomplete="nope"
                data-lpignore="true"
                v-validate="'max:11'"
                data-vv-validate-on="input"
            >
            <show-errors :for-item="'currentFormData.bankSwiftCode'"
                         :form-errors="errors"
                         :field-name="FORM_LABELS.BANK_SWIFT_CODE"
                         :max-length="11" />
          </div>
        </div>


      </div>

    </div>
  </div>
</template>

<script>
import {ModelListSelect} from "vue-search-select";
import CONSTANTS from "@/store/constants";
import PaymentFormsMixin from "@/mixins/PaymentFormsMixin";
import HeaderWithTooltip from "@/components/HeaderWithTooltip";
import {mapGetters, mapMutations} from "vuex";

export default {
  name: "BankTransferForm",
  mixins: [PaymentFormsMixin],
  components: {ModelListSelect,HeaderWithTooltip},
  props: {
    formData: String
  },
  inject: ['$validator'],
  methods: {
    ...mapMutations(["setIsBankDetailsCheckedAsHidden"]),
    updateBankCountry(country) {
      this.currentFormData.bankCountry = country
      this.componentKey++
      //Disable autocomplete again since we're refreshing component with componentKey
      setTimeout(() => {
        this.disableAutofill('bank-country-list')
      }, 200)
    },
    updateBankDetails(){
      if (this.bankDetailsDropdownValues.length > 0) {
        this.bankAccountValues = JSON.parse(JSON.stringify(this.bankDetailsDropdownValues))
        let key = 0
        this.bankAccountValues = this.bankAccountValues.map((val)=>{
          if (val.bankAccount && val.bankAccount !== ""){
            this.setIsBankDetailsCheckedAsHidden(true);
            key++;
            return {value: val.bankAccount, text: val.bankAccount, key: key}
          }else{
            this.setIsBankDetailsCheckedAsHidden(false);
          }
        })
      }else{
        this.setIsBankDetailsCheckedAsHidden(false);
      }
    },
    autofillBankDetails(){
        this.showBankAccount = false
        this.maskBankAccountNumbers()
        let bankObject = this.bankDetailsDropdownValues.find((bankDetails)=>bankDetails.bankAccount === this.currentFormData.bankAccountNumber)
        this.currentFormData.bankName = this.getBankData(bankObject.bankName)
        this.currentFormData.bankAccountHolderName = this.getBankData(bankObject.accountHolderName)
        this.currentFormData.bankNumber = this.getBankData(bankObject.bankNumber)
        this.currentFormData.bankSwiftCode = this.getBankData(bankObject.bankSwift)
        this.currentFormData.bankIBAN = this.getBankData(bankObject.iban)
        this.currentFormData.bankCountry = this.getBankData(bankObject.country)

      this.bankAccountNumberKey++
    },
    maskBankAccountNumbers(){
      if (this.bankAccountValues && this.bankAccountValues.length>0){
        this.bankAccountValuesMasked = this.bankAccountValues.map((val)=>{
          if (val.value && val.value !== ""){
            this.maskedKey++;
            let maskedValue = ""
            for (let i = 0; i < val.value.length; i++) {
              maskedValue = maskedValue + "x";
            }
            return {value: val.value, text: maskedValue, key: this.maskedKey}
          }
        })
      }
    },
    getBankData(bankData){
      if (bankData) return bankData
        else  return ""
    },
  },
  computed: {
    ...mapGetters(["bankDetailsDropdownValues","isBankDetailsCheckedAsHidden","adminDataList"]),
    currentFormData() {
      return this.$store.getters[this.formData]
    },
  },
  data() {
    return {
      showBankAccount: true,
      showBankAccountWhenFormNotPONONPO: false,
      isMarkedAsReadOnly: false,
      showIBAN: false,
      componentKey: 0,
      bankAccountNumberKey: 0,
      bankAccountValues: [],
      bankAccountValuesMasked: [],
      maskedKey: 0,
      bankAccountNumberSlackHelp: `<span>
      If you don't see a specific Bank account number, please contact <a href=${CONSTANTS.ACCOUNTS_PAYABLE_SLACK} target="_blank">Accounts Payable via Lumi</a>
      </span>`
    }
  },

  mounted() {
    //apply autocomplete to a random string so that browser do not suggest countries which overrides the dropdown.
    this.disableAutofill('bank-country-list')
    this.updateBankDetails()
    this.maskBankAccountNumbers()
  },
}
</script>

<style scoped>

.hidden-input-field {
  position: absolute;
  left: -1000px;
  top: -10px
}

.text-red {
  color: #FF0000;
}

.readonly-dropdown {
  background-color: #e9ecef !important;
  opacity: 1 !important;
}
</style>

<style scoped src="@/assets/stylesheets/vueSearchSelectOverrides.css">

</style>